import insertData from "./create-direct-customer-quote/insert-data";
import paymentMarginOnePointOne from "./create-direct-customer-quote/payment-margin-one-point-one";
import paymentMarginOnePointO from "./create-direct-customer-quote/payment-margin-one-point-o";
import vendorSelection from "./create-direct-customer-quote/vendor-selection";
import specificRateCardSelection from "./create-direct-customer-quote/specific-rate-card-selection";
import vendorMatrix from "./create-direct-customer-quote/vendor-matrix";
import maxNetValue from "./create-direct-customer-quote/max-net-value";
import dealListColumnsSpecification from "./deal/dealListColumnsSpecification";
import dealDetailsColumnsSpecification from "./deal/dealDetailsColumnsSpecification";
import countryAndPaymentTypeColumnsSpecification from "./deal/countryAndPaymentTypeColumnsSpecification";
import countryAndAssetTypeColumnsSpecification from './deal/countryAndAssetTypeColumnsSpecification';
import createDealDetailColumnsSpecification from './deal/createDealDetailColumnsSpecification';
import insertCountryAndPaymentTypeColumnsSpecification from "./deal/insertCountryAndPaymentTypeColumnsSpecification";
import insertCountryAndAssetTypeColumnsSpecification from './deal/insertCountryAndAssetTypeColumnsSpecification';
import myQuotesTableColumns from "./my-dashboard/myQuotesTableColumns";
import vendorCTInitialQuotesTableColumns from './my-dashboard/vendorCTInitialQuotesTableColumns';
import myDashboardDCDealsTableColumns from "./my-dashboard/myDashboardDCDealsTableColumns";
import myOrdersTableColumns from "./my-dashboard/myOrdersTableColumns";
import myReportsTableColumns from "./my-dashboard/myReportsTableColumns";
import customizedReportsTableColumns from "./my-dashboard/customizedReportsTableColumns";
import exportPartnerFinancialsTableColumns from "./my-dashboard/exportPartnerFinancialsTableColumns";
import consolidatedReportsListTableColumns from "./my-dashboard/consolidatedReportsListTableColumns";
import partnerFinancialsReportsListTableColumns from "./my-dashboard/partnerFinancialsReportsListTableColumns";
import myPaymentsTableColumns from "./my-dashboard/myPaymentsTableColumns";
import quoteDetailsTableColumns from "./my-dashboard/quoteDetailsTableColumns";
import directCheckoutAsset from "./direct-checkout/direct-checkout-asset";
import directCustomerOrderListColumnsSpecification from './direct-customers/directCustomerOrderListColumnsSpecification';
import indirectCustomerOrderListColumnsSpecification from './indirect-customers/indirectCustomerOrderListColumnsSpecification';
import indirectCustomerOrdersColumnsSpecification from './indirect-customers/indirectCustomerOrdersColumnsSpecification';
import directCustomerOrdersColumnsSpecification from './direct-customers/directCustomerOrdersColumnsSpecification';
import directCustomerOrderDetailColumnsSepcification from "./direct-customers/directCustomerOrderDetailColumnsSepcification";
import orderInformationColumnsSpecification from './direct-customers/orderInformationColumnsSpecification';
import reportColumnsSpecification from './direct-customers/reportColumnsSpecification';
import assetInformationColumnsSpecificataion from './direct-customers/assetInformationColumnsSpecificataion';
import inquiryStatusColumnsSpecification from './direct-customers/inquiryStatusColumnsSpecification';
import financialsColumnsSpecification from './direct-customers/financialsColumnsSpecification';
import controlTowerInitialQuotesColumnSpecification from "./control-tower/controlTowerInitialQuotesColumnSpecification";
import editQuoteColumnSpecification from "./control-tower/editQuoteColumnSpecification";
import vendorResultsColumnSpecification from "./control-tower/vendorResultsColumnSpecification";
import residualValueManagementColumnSpecification from "./control-tower/residualValueManagementColumnSpecification";
import pyxtechCountryVendorColumnSpecification from "./control-tower/pyxtechCountryVendorColumnSpecification";
import paymentMarginOnePointOneCT from "./control-tower/payment-margin-one-point-one";
import indirectCustomerFinancials from "./indirect-customers/indirectCustomerFinancialsColumnSpecification";
import indirectFinancialsColumnsSpecification from './indirect-customers/indirectFinancialsColumnSpecification';
import directFinancialsColumnsSpecification from './direct-customers/directFinancialsColumnSpecification';
import partnerFinancialsColumnsSpecification from "./control-tower/partnerFinancialsColumnsSpecification";
import directCustomerFinancials from './direct-customers/directCustomerFinancialsColumnSpecification';
import vendorFinancialsDirectCustomer from "./vendor/vendorFinancialsDirectCustomerColumnSpecification";
import vendorFinancialsIndirectCustomer from "./vendor/vendorFinancialsIndirectCustomerColumnSpecification";
import indirectCustomerCTInitialQuotesColumnsSpecification from './indirect-customers/indirectCustomerCTInitialQuotesColumnsSpecification';
import directCustomerCTInitialQuotesColumnsSpecification from './direct-customers/directCustomerCTInitialQuotesColumnsSpecification';
import directCustomerCTQuoteDetails from './direct-customers/quoteDetailsTableColumns';
import contactAndAdditionalInformationColumnsSpecification from "./direct-customers/contactAndAdditionalInformationColumnsSpecification";
import servicesRequestedColumnSpecification from "./direct-customers/servicesRequestedColumnSpecification";
import quoteDetailsAdditionalCommentsAndServiceReqested from './direct-customers/quoteDetailsAdditionalCommentsAndServiceReqested';
import quoteDetailsShippingAndBillingAddress from './direct-customers/quoteDetailsShippingAndBillingAddress';
import customerEntityListColumnsSpecification from "./customer-entity/customerEntityListColumnsSpecification";
import createCustomerEntityDetailColumnsSpecification from "./customer-entity/createCustomerEntityDetailColumnsSpecification";
import legalEntityTableColumnsSpecification from "./customer-entity/legalEntityTableColumnsSpecification";
import selectLegalEntitiesColumnsSpecification from "./deal/selectLegalEntitiesColumnsSpecification";
import selectedLegalEntityColumnsSpecification from "./deal/selectedLegalEntityColumnsSpecification";
import hpRevitalizeColumnSpecification from "./control-tower/hpRevitalizeColumnSpecification";
import ctQuoteDetailsColumnsSpecification from "./deal/ctQuoteDetailsColumnsSpecification";
export default function drsTableDataTransform(config) {
    if (!config.data) return null;
    
    let transformedData = null;

    switch (config.tableType) {
        case "drs-create-direct-customer-quote-insert-data": {
            transformedData = insertData(config);
            break;
        }

        case "drs-create-direct-customer-quote-margin1.1": {
            transformedData = paymentMarginOnePointOne(config);
            break;
        }

        case "drs-create-direct-customer-quote-margin1.0": {
            transformedData = paymentMarginOnePointO(config);
            break;
        }

        case "drs-create-direct-customer-quote-vendor-selection": {
            transformedData = vendorSelection(config);
            break;
        }
        case "drs-create-direct-customer-quote-customer-specific-rate-card-selection": {
            transformedData = specificRateCardSelection(config);
            break;
        }

        case "drs-create-direct-customer-quote-vendor-matrix": {
            transformedData = vendorMatrix(config);
            break;
        }

        case "drs-create-direct-customer-quote-max-net-value": {
            transformedData = maxNetValue(config);
            break;
        }

        case "drs-deal-list": {
            transformedData = dealListColumnsSpecification(config);
            break;
        }
        case "drs-customer-entity-list": {
            transformedData = customerEntityListColumnsSpecification(config);
            break;
        }

        case "drs-deal-detail": {
            transformedData = dealDetailsColumnsSpecification(config);
            break;
        }

        case "drs-deal-detail-country-and-payment-type": {
            transformedData = countryAndPaymentTypeColumnsSpecification(config);
            break;
        }
        
        case "drs-deal-detail-legalentity": {
            transformedData = selectedLegalEntityColumnsSpecification(config);
            break;
        }

        case "drs-deal-detail-country-and-asset-type": {
            transformedData = countryAndAssetTypeColumnsSpecification(config);
            break;
        }

        case "drs-create-new-deal-detail": {
            transformedData = createDealDetailColumnsSpecification(config);
            break;
        }

        case "drs-create-new-customerentity-detail": {
            transformedData = createCustomerEntityDetailColumnsSpecification(config);
            break;
        }

        case "drs-insert-country-and-payment-type": {
            transformedData = insertCountryAndPaymentTypeColumnsSpecification(config);
            break;
        }

        case "drs-country-and-legalentity-table": {
            transformedData = legalEntityTableColumnsSpecification(config);
            break;
        }

        case "drs-deal-legalentity-table": {
            transformedData = selectLegalEntitiesColumnsSpecification(config);
            break;
        }

        case "drs-ct-quote-details": {
            transformedData = ctQuoteDetailsColumnsSpecification(config);
            break;
        }

        case "drs-insert-country-and-asset-type": {
            transformedData = insertCountryAndAssetTypeColumnsSpecification(config);
            break;
        }

        case "drs-myDashboard-myQuotes": {
            transformedData = myQuotesTableColumns(config);
            break;
        }

        case "drs-vendor-ctinitialquotes": {
            transformedData = vendorCTInitialQuotesTableColumns(config);
            break;
        }
        
        case "drs-myDashboard-deals-directCustomer": {
            transformedData = myDashboardDCDealsTableColumns(config);
            break;
        }

        case "drs-myDashboard-myOrders": {
            transformedData = myOrdersTableColumns(config);
            break;
        }
        // /This is done for custime column view. Same table type giving issue so, we changed name but code is same for three tables
        case "drs-myDashboard-myReports":
        case "drs-myDashboard-myReports-indirect":
        case "drs-myDashboard-myReports-direct": {
            transformedData = myReportsTableColumns(config);
            break;
        }
        case "drs-myDashboard-customizedReports": {
            transformedData = customizedReportsTableColumns(config);
            break;
        }
        case "drs-myDashboard-exportPartnerFinancials": {
            transformedData = exportPartnerFinancialsTableColumns(config);
            break;
        }
        case "drs-consolidated-reports": {
            transformedData = consolidatedReportsListTableColumns(config);
            break;
        }
        case "drs-partner-financials-reports-list": {
            transformedData = partnerFinancialsReportsListTableColumns(config);
            break;
        }
        case "drs-myDashboard-myPayments": {
            transformedData = myPaymentsTableColumns(config);
            break;
        }
        case "drs-myDashboard-quoteDetails": {
            transformedData = quoteDetailsTableColumns(config);
            break;
        }
        case "drs-create-direct-checkout-asset-selection": {
            transformedData = directCheckoutAsset(config);
            break;
        }
        case "drs-direct-customers-order-list": {
            transformedData = directCustomerOrderListColumnsSpecification(config);
            break;
        }
        case "drs-indirect-customers-order-list": {
            transformedData = indirectCustomerOrderListColumnsSpecification(config);
            break;
        }
        case "drs-indirect-customers-orders": {
            transformedData = indirectCustomerOrdersColumnsSpecification(config);
            break;
        }
        case "drs-direct-customers-orders": {
            transformedData = directCustomerOrdersColumnsSpecification(config);
            break;
        }
        case "drs-direct-customers-order-detail": {
            transformedData = directCustomerOrderDetailColumnsSepcification(config);
            break;
        }
        case "drs-order-information": {
            transformedData = orderInformationColumnsSpecification(config);
            break;
        }
        case "drs-contact-and-additional-information": {
            transformedData = contactAndAdditionalInformationColumnsSpecification(config);
            break;
        }
        case "drs-services-requested-information": {
            transformedData = servicesRequestedColumnSpecification(config);
            break;
        }

        case "drs-quote-shipping-and-billing-address": {
            transformedData = quoteDetailsShippingAndBillingAddress(config);
            break;
        }
        case "drs-quote-additional-comments-and-service-requested": {
            transformedData = quoteDetailsAdditionalCommentsAndServiceReqested(config);
            break;
        }

        case "drs-asset-information": {
            transformedData = assetInformationColumnsSpecificataion(config);
            break;
        }
        case "drs-report-information": {
            transformedData = reportColumnsSpecification(config);
            break;
        }
        case "drs-inquiry-status": {
            transformedData = inquiryStatusColumnsSpecification(config);
            break;
        }
        case "drs-financial-information": {
            transformedData = financialsColumnsSpecification(config);
            break;
        }
        case "drs-control-tower-initial-quotes": {
            transformedData = controlTowerInitialQuotesColumnSpecification(config);
            break;
        }
        case "drs-edit-quote-data": {
            transformedData = editQuoteColumnSpecification(config);
            break;
        }
        case "drs-vendor-results": {
            transformedData = vendorResultsColumnSpecification(config);
            break;
        }
        case "drs-residual-value-management": {
            transformedData = residualValueManagementColumnSpecification(config);
            break;
        }
        case "drs-pyxtech-country-vendor": {
            transformedData = pyxtechCountryVendorColumnSpecification(config);
            break;
        }
        case "drs-hp-revitalize-results": {
            transformedData = hpRevitalizeColumnSpecification(config);
            break;
        }
        case "drs-create-ct-initial-quote-margin1.1": {
            transformedData = paymentMarginOnePointOneCT(config);
            break;
        }
        case "drs-indirect-customers-my-payments": {
            transformedData = indirectCustomerFinancials(config);
            break;
        }
        case "drs-financial-indirect-customers": {
            transformedData = indirectFinancialsColumnsSpecification(config);
            break;
        }
        case "drs-financial-direct-customers": {
            transformedData = directFinancialsColumnsSpecification(config);
            break;
        }
        case "drs-financial-partner": {
            transformedData = partnerFinancialsColumnsSpecification(config);
            break;
        }
        case "drs-direct-customers-my-payments": {
            transformedData = directCustomerFinancials(config);
            break;
        }
        case "drs-financial-list-for-direct-customers": {
            transformedData = vendorFinancialsDirectCustomer(config);
            break;
        }  
        case "drs-financial-list-for-indirect-customers": {
            transformedData = vendorFinancialsIndirectCustomer(config);
            break;
        } 
        case "drs-indirect-customers-ct-initial-quotes": {
            transformedData = indirectCustomerCTInitialQuotesColumnsSpecification(config);
            break;
        } 
        case "drs-direct-customers-ct-initial-quotes": {
            transformedData = directCustomerCTInitialQuotesColumnsSpecification(config);
            break;
        }  
        case "drs-direct-customer-ct-quoteDetails": {
            transformedData = directCustomerCTQuoteDetails(config);
            break;
        }        
        default: {
            // nothing to do
            break;
        }
    }

    return transformedData;
}